import * as yup from 'yup';

import email, { validEmailRegex } from '@hero/validators/email';
import emailDomain from '@hero/validators/email-domain';
import phone from '@hero/validators/libphonenumber';

// the \u0000 range bound is deliberate: this matches anything outside Latin-1
// eslint-disable-next-line no-control-regex
const regex = /[^\u0000-\u00ff]/; // check for unicode characters

export const phoneYupValidation = yup.lazy((val?: string) => {
    if (!val) {
        return yup.string().trim().required('Phone number is required');
    } else if (regex.test(`${val}`)) {
        return yup
            .string()
            .trim()
            .test('special-chars', 'Phone number invalid', () => false);
    } else {
        return phone;
    }
}) as unknown as yup.StringSchema<string, object>;

export const phoneYupValidationNotRequired = yup.lazy((val?: string) => {
    if (!val) {
        return yup.string().trim().notRequired();
    } else {
        return phoneYupValidation;
    }
}) as unknown as yup.StringSchema<string, object>;

export const emailYupValidation = yup.lazy((val?: string) => {
    if (!val) {
        return yup.string().trim().required('Email is required');
    } else if (!validEmailRegex.test(`${val}`)) {
        return email;
    } else {
        return emailDomain;
    }
}) as unknown as yup.StringSchema<string, object>;

export const emailYupValidationNotRequired = yup.lazy((val?: string) => {
    if (!val) {
        return yup.string().trim().notRequired();
    } else {
        return emailYupValidation;
    }
}) as unknown as yup.StringSchema<string, object>;
